import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubmissionStateEnum } from '../../../../models/users/enum/submission-state-enum';
import { BaseInfoItem } from '../../../profile/models/base-info-item';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-submission-detail-grid',
  templateUrl: './submission-detail-grid.component.html',
  styleUrls: ['./submission-detail-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionDetailGridComponent implements OnChanges {
  @Input() infoItems: BaseInfoItem[] = [];
  @Input() submissionInfoState: SubmissionStateEnum = SubmissionStateEnum.New;
  @Input() hideLabel: boolean = false;

  private _infoItems = new BehaviorSubject<BaseInfoItem[]>([]);
  public infoItems$ = this._infoItems as Observable<BaseInfoItem[]>;

  private _submissionState = new BehaviorSubject<SubmissionStateEnum>(SubmissionStateEnum.New);
  public submissionState$ = this._submissionState as Observable<SubmissionStateEnum>;

  public label$ = this.submissionState$.pipe(
    map((state: SubmissionStateEnum) => {
      switch (state) {
        case SubmissionStateEnum.New:
          return $localize`New`;
        case SubmissionStateEnum.Previous:
          return $localize`Previous`;
      }
    })
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.infoItems) {
      this._infoItems.next(this.infoItems);
    }
    if (changes.submissionInfoState) {
      this._submissionState.next(this.submissionInfoState);
    }
  }
}
